<div class="modal-header modal-pepsico-header">
    <h1 class="modal-title fs-5" id="exampleModalLabel">¡Listo!</h1>
</div>
<div class="modal-body">

    <div class="modal-body">
        <div class="d-flex jf-center">
        <img src="assets/images/item-open.png" alt="" width="100px">
        </div>
          <p class="foto-tutorial-txt mt-3">
            {{message()}}
          </p>
          <div class="order-tracking-unique">
            <div class="d-flex jf-center">
              <button type="button" class="btn btn-primary perfilbtn-pep hw-modal-par"
                (click)="close()">Cerrar</button>
            </div>
          </div>

    </div>


</div>